import React from 'react';
import styles from './Gallery.module.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../Button/Button';
import Heading from '../Heading/Heading';

const Gallery = ({ ranking, list, unlocked, close, open }) => {
  const compare = (a, b) => {
    if (a.description < b.description) {
      return -1;
    }
    if (a.description > b.description) {
      return 1;
    }
    return 0;
  };

  const myLegend = list.sort(compare).map((emoji) => {
    const isUnlocked = unlocked.indexOf(emoji.emoji) !== -1;
    if (isUnlocked) {
      return (
        <div
          key={`unlock-${emoji.emoji}`}
          className={classNames(styles.emoji, {
            [styles.unlocked]: isUnlocked,
          })}
        >
          <div className={styles.symbol}>{emoji.emoji}</div>
          <div className={styles.description}>{emoji.description}</div>
        </div>
      );
    } else {
      return null;
    }
  });

  const legend = list.sort(compare).map((emoji) => {
    const isUnlocked = unlocked.indexOf(emoji.emoji) !== -1;
    return (
      <div
        key={`legend-${emoji.emoji}`}
        className={classNames(styles.emoji, { [styles.unlocked]: isUnlocked })}
      >
        <div className={styles.symbol}>{emoji.emoji}</div>
        <div className={styles.description}>{emoji.description}</div>
      </div>
    );
  });

  return (
    <section className={classNames(styles.wrapper, { [styles.open]: open })}>
      <div className={styles.close}>
        <Button onClick={close}>Close</Button>
      </div>
      <div className={styles.list}>
        <div className={styles.content}>
          {ranking && (
            <div className={styles.rank}>
              <Heading className={styles.score}>
                {ranking.ranking} / {ranking.players} Global ranking
              </Heading>
            </div>
          )}
          <Heading className={styles.title}>
            {unlocked.length} Unlocked emojis
          </Heading>
          <div className={styles.section}>{myLegend}</div>
          <Heading className={styles.title}>All {list.length} emojis</Heading>
          <div className={styles.section}>{legend}</div>
        </div>
      </div>
    </section>
  );
};

Gallery.propTypes = {
  ranking: PropTypes.exact({
    ranking: PropTypes.number,
    players: PropTypes.number,
  }),
  list: PropTypes.array,
  unlocked: PropTypes.array,
  close: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

Gallery.defaultProps = {
  ranking: null,
  list: [],
  unlocked: [],
  close: null,
  open: false,
};

export default Gallery;
